// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .bg-zikata {
        background-color: #2e005d;
      }
      .navbar {
        transition: margin-left 0.3s ease;
      }
      :host ::ng-deep .mobile-menu {
        right: 1rem; /* Add some spacing from the right edge in mobile view */
      }
    `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/sections/zikata-header/zikata-header.component.ts"],"names":[],"mappings":";MACM;QACE,yBAAyB;MAC3B;MACA;QACE,iCAAiC;MACnC;MACA;QACE,WAAW,EAAE,wDAAwD;MACvE","sourcesContent":["\n      .bg-zikata {\n        background-color: #2e005d;\n      }\n      .navbar {\n        transition: margin-left 0.3s ease;\n      }\n      :host ::ng-deep .mobile-menu {\n        right: 1rem; /* Add some spacing from the right edge in mobile view */\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
